export default __webpack_public_path__ + "static/media/care.d3996eaf.png";